import React from 'react'
import ScrollComponents from '../../../../widgets/scrollComponents'
import './style.scss'

const fadeRightInAnimation = {
  loop: false,
  from: { opacity: 0, x: -100 },
  to: { opacity: 1, x: 0 },
  config: {
    duration: 500,
  },
  delay: 100,
}

const fadeLeftInAnimation = {
  loop: false,
  from: { opacity: 0, x: 100 },
  to: { opacity: 1, x: 0 },
  config: {
    duration: 500,
  },
  delay: 100,
}

function RoleFrame() {
  return (
    <div className={'intro-content-container intro-frame-1-container'}>
      <div className={'intro-frame-1-text-placeholder'}>
        <span>
        <ScrollComponents springConfig={fadeRightInAnimation}>
          Software Engineer
        </ScrollComponents>
        <ScrollComponents springConfig={fadeLeftInAnimation}>
          Web Developer
        </ScrollComponents>
        <ScrollComponents springConfig={fadeRightInAnimation}>
          Competitive Programmer
        </ScrollComponents>
        </span>
      </div>
    </div>
  )
}

export default RoleFrame
